import React from 'react';
import c from 'classnames';
import config from 'react-global-configuration';
import { CoreLink } from '..';

import './style.scss';

const Logo = ({ isCampaign, forceMainLogo = false }) => {
  let rootUrl;
  if (isCampaign) {
    // eslint-disable-next-line prefer-destructuring
    rootUrl = `/${window.location.pathname.split('/')[1]}`;
  }

  const classes = c({
    'Logo--isCampaign': isCampaign,
    'Logo--kp': !forceMainLogo && config.get('CURRENT_DOMAIN') === 'kp',
    Logo: true,
  });
  return (
    <CoreLink className={classes} to={rootUrl || '/'} />
  );
};

export default Logo;
